import { useEffect, useMemo } from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';

import { auth as appClientAuth } from '@edf-pkg/app-client';

import { ON_PREMISE_INSTANCES } from '$app-web/constants';
import usePage from '$app-web/hooks/use-page';
import ButtonGroup from '$app-web/modules/auth/components/button-group';
import Logo from '$app-web/modules/auth/components/logo';
import { getEnvironmentName, getIsACT, URLsManager } from '$app-web/utils';

import StudyInfo from './components/study-info';
import useStyles from './styles';

const PageWelcome = (props) => {
    const { studyBasicInfo, hasStudyBasicInfo } = props;
    const classes = useStyles();
    const resetState = appClientAuth.useAuthenticationStore((store) => store.resetState);

    const { t } = useTranslation();

    const isEDENInstance = useMemo(() => {
        return getEnvironmentName() === ON_PREMISE_INSTANCES.EDEN;
    }, []);

    usePage(t('pdash:web_app_introduction_welcome_title', [process.env.REACT_APP_PAGE_TITLE_BASE]));
    const isACT = useMemo(() => getIsACT(), []);

    const sharedButtonProps = {
        component: Link,
        className: clsx(classes.button, {
            [classes.buttonWithStudyInfo]: hasStudyBasicInfo,
            containedACTColor: isACT,
        }),
        wrapperClassName: classes.buttonWrapper,
    };

    useEffect(() => {
        resetState();
    }, [resetState]);

    return (
        <>
            <Grid item>
                <Logo />
            </Grid>
            <Grid item>
                <Typography variant="subtitle1" align="center">
                    {t('pdash:web_app_introduction_welcome_title', [process.env.REACT_APP_PAGE_TITLE_BASE])}
                </Typography>
            </Grid>
            {hasStudyBasicInfo && (
                <Grid item>
                    <StudyInfo studyBasicInfo={studyBasicInfo} />
                </Grid>
            )}
            <Grid className={classes.buttonGroupWrapper} item>
                <ButtonGroup
                    direction={hasStudyBasicInfo ? 'row' : 'column'}
                    spacing={hasStudyBasicInfo ? 2 : 4}
                    buttons={[
                        {
                            ...sharedButtonProps,
                            key: 'SIGN_IN',
                            to: URLsManager.to('dashboard:auth:SIGN_IN'),
                            text: t('pdash:login_button_text'),
                            label: !hasStudyBasicInfo && t('pdash:signup_already_a_member'),
                        },
                        ...(!isEDENInstance
                            ? [
                                  {
                                      ...sharedButtonProps,
                                      key: 'SIGN_UP',
                                      to: URLsManager.to('dashboard:auth:SIGN_UP'),
                                      text: t('pdash:login_signup_text'),
                                      label: !hasStudyBasicInfo && t('pdash:login_dont_have_account'),
                                  },
                              ]
                            : []),
                    ]}
                />
            </Grid>
        </>
    );
};

PageWelcome.defaultProps = {
    studyBasicInfo: {},
    hasStudyBasicInfo: false,
};

PageWelcome.propTypes = {
    studyBasicInfo: PropTypes.shape({
        name: PropTypes.string,
        orgName: PropTypes.string,
    }),
    hasStudyBasicInfo: PropTypes.bool,
};

export default PageWelcome;
